module.exports = __webpack_public_path__ + "static/img/Garage_Kits_bg.1801d6cb.jpg";